import { render, staticRenderFns } from "./ReportNotes.vue?vue&type=template&id=0198449d&scoped=true"
import script from "./ReportNotes.vue?vue&type=script&lang=js"
export * from "./ReportNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198449d",
  null
  
)

export default component.exports